import { z } from 'zod';

import { axios } from '../axios';
import { nextApiRoutes } from './config';

export const recaptchaResponseSchema = z.object({
  success: z.boolean(),
  score: z.number().min(0).max(1).optional(),
  actionVerified: z.string().optional(),
  errorCodes: z.array(z.string()).optional(),
});

export type RecaptchaResponse = z.infer<typeof recaptchaResponseSchema>;

export const recaptchaV3 = async ({
  action,
  token,
}: {
  action: string;
  token: string;
}) => {
  const { data } = await axios.post(nextApiRoutes.recaptchaV3, {
    action,
    token,
  });
  return recaptchaResponseSchema.parse(data);
};
